"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importDefault(require("react"));
var Provider_1 = __importDefault(require("../../Provider"));
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var useSearchProviders_1 = require("./useSearchProviders");
var next_intl_1 = require("next-intl");
var ProvidersExpandedState = function (_a) {
    var cancelViewAll = _a.cancelViewAll;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _b = (0, useSearchProviders_1.useSearchProviders)(), searchValue = _b.searchValue, onSearchChange = _b.onSearchChange, onSearchClear = _b.onSearchClear, allProviders = _b.allProviders;
    if (!allProviders)
        return null;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.mobileContainer },
            react_1.default.createElement(ui_components_1.SearchInput, { withClear: false, value: searchValue, onChange: onSearchChange, onClear: onSearchClear, placeholder: t('search') }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.providers }, allProviders === null || allProviders === void 0 ? void 0 : allProviders.map(function (item, idx) { return (react_1.default.createElement(Provider_1.default, __assign({ key: "provider".concat(idx) }, item))); }))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.mobileButtonWrapper },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "primary", variant: "outline", text: "upper", onClick: cancelViewAll, maxWidth: "100%" }, t('cancel')))));
};
exports.default = ProvidersExpandedState;
